module.exports = __webpack_public_path__ + "img/Arabic-09.fa973cce.jpg";